var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#D0D7DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 31.5C15.4188 31.5 13 29.1964 13 26.3571C13 24.1143 14.5075 22.2071 16.6075 21.5036C16.6037 21.4071 16.6 21.3107 16.6 21.2143C16.6 18.0571 19.285 15.5 22.6 15.5C24.8238 15.5 26.7625 16.65 27.8013 18.3643C28.3713 18 29.0613 17.7857 29.8 17.7857C31.7875 17.7857 33.4 19.3214 33.4 21.2143C33.4 21.65 33.3137 22.0643 33.16 22.45C35.35 22.8714 37 24.7179 37 26.9286C37 29.4536 34.8513 31.5 32.2 31.5H18.4ZM21.3625 23.75C21.01 24.0857 21.01 24.6286 21.3625 24.9607C21.715 25.2929 22.285 25.2964 22.6337 24.9607L24.0963 23.5679V28.3571C24.0963 28.8321 24.4975 29.2143 24.9963 29.2143C25.495 29.2143 25.8963 28.8321 25.8963 28.3571V23.5679L27.3588 24.9607C27.7113 25.2964 28.2812 25.2964 28.63 24.9607C28.9788 24.625 28.9825 24.0821 28.63 23.75L25.63 20.8929C25.2775 20.5571 24.7075 20.5571 24.3588 20.8929L21.3588 23.75H21.3625Z",
    fill: "#3A3A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconLight);
export default __webpack_public_path__ + "static/media/upload-icon-light.9b3ae8406eadb690f8df2ecb6eed1bd2.svg";
export { ForwardRef as ReactComponent };